import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import {
  AdjustCreditPage,
  CreditWalletPage,
  PendingReviewTopUpsPage,
  TopUpCreditPage,
  TopupCryptoPage,
} from '../lazyPages';

export const CreditWalletRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.CREDIT_WALLET')}>
            <CreditWalletPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="topup-credit"
        element={
          <GuardedPageRoute pageName={t('TOPUP_CREDIT')} action="create">
            <TopUpCreditPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="adjust-credit"
        element={
          <GuardedPageRoute pageName={t('ADJUST_CREDIT')} action="create">
            <AdjustCreditPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="topup-crypto"
        element={
          <GuardedPageRoute pageName={t('TOPUP_CRYPTO')} action="create">
            <TopupCryptoPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="pending-review"
        element={
          <GuardedPageRoute pageName="รอตรวจสอบสลิป">
            <PendingReviewTopUpsPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
